import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Button from '@mui/material/Button';
import InputLabel from '@mui/material/InputLabel';
import Stack from '@mui/material/Stack';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

import useStyles from '../common/styles';

import i18n from "i18next";
import { useTranslation } from "react-i18next";

import {
  useHistory,
} from 'react-router-dom';

import Logo from '../assets/logo.png';

import "/node_modules/flag-icons/css/flag-icons.min.css";
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import 'dayjs/locale/ko';
import 'dayjs/locale/en';
import TextField from '@mui/material/TextField';
import Container from '@mui/material/Container';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { useFormik } from 'formik';
import { backendURL } from '../App';
import { useState } from 'react';
import dayjs from 'dayjs';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';

const callTimeOptions = [
  { value: '09:00-10:00', label: '09:00 ~ 10:00' },
  { value: '10:00-11:00', label: '10:00 ~ 11:00' },
  { value: '11:00-12:00', label: '11:00 ~ 12:00' },
  { value: '13:00-14:00', label: '13:00 ~ 14:00' },
  { value: '14:00-15:00', label: '14:00 ~ 15:00' },
  { value: '15:00-16:00', label: '15:00 ~ 16:00' },
  { value: '16:00-17:00', label: '16:00 ~ 17:00' },
  { value: '17:00-18:00', label: '17:00 ~ 18:00' },
  { value: '18:00-', label: '18:00 ~' },
];

export default function Invitation({ participantInfo }: { participantInfo?: Record<string, any> }) {
  const classes = useStyles();
  const { t } = useTranslation();
  const history = useHistory();
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.only('xs'));


  const [isArrivalDisabled, setIsArrivalDisabled] = useState(true);
  const [isDepartureDisabled, setIsDepartureDisabled] = useState(true);
  const [isPrivacyAgreed, setIsPrivacyAgreed] = useState(false);
  const [isAlertDialogOpen, setIsAlertDialogOpen] = useState(false);
  const [alertTitle, setAlertTitle] = useState('');
  const [alertMessage, setAlertMessage] = useState('');

  const privacyContentRaw = t('privacyContent').replace(/^ +/gm, '');
  const privacyLines = privacyContentRaw
    .split('\n')
    .map((line) => line.trim())
    .filter(Boolean);
  const privacyLastSentence = privacyLines[privacyLines.length - 1] || '';
  const privacyMainParagraph = privacyLines.slice(0, -1).join(' ').replace(/\s{2,}/g, ' ').trim();
  const privacyContent = isXs
    ? `${privacyMainParagraph}\n\n${privacyLastSentence}`.trim()
    : privacyContentRaw;

  const openAlertDialog = (title: string, message: string) => {
    setAlertTitle(title);
    setAlertMessage(message);
    setIsAlertDialogOpen(true);
  }

  const getAllowedGloveSizes = (gender: string) => {
    if (gender === 'M') {
      return ['22', '23', '24', '25', '26'];
    }

    if (gender === 'F') {
      return ['18', '19', '20', '21', '22'];
    }

    return [];
  };

  const formik = useFormik({
    initialValues: {
      name: participantInfo?.name || '',
      nameEng: "",
      gender: participantInfo?.gender || '',
      birthdate: "",
      nationality: "",
      address: "",
      company: "",
      position: "",
      phoneNumber: "",
      recipient: "",
      recipientName: "",
      recipientPhoneNumber: "",
      recipientRelation: "",
      preferredCallDate: "",
      preferredCallTime: "",
      flight: '',
      flightDeparture: "",
      flightArrival: "",
      bagService: "",
      bagAddress: "",
      bagScheduleDate: "",
      bagServicePhoneNumber: "",
      shoeGender: participantInfo?.shoeGender || '',
      shoeSize: participantInfo?.shoeSize || '',
      gloveSize: "",
      gloveLeftRight: "",
      gloveGender: participantInfo?.gloveGender || participantInfo?.gender || '',
      food: "",
    },
    onSubmit: (form) => {
      form.birthdate = dayjs(form.birthdate).format('YYYY-MM-DD');

      const requiredFields = [
        'name',
        'nameEng',
        'birthdate',
        'nationality',
        'address',
        'company',
        'position',
        'phoneNumber',
        'recipient',
        'recipientName',
        'recipientPhoneNumber',
        'recipientRelation',
        'preferredCallDate',
        'preferredCallTime',
        'flight',
        'flightDeparture',
        'flightArrival',
        'bagService',
        'bagAddress',
        'bagScheduleDate',
        'bagServicePhoneNumber',
        'shoeGender',
        'shoeSize',
        'gloveSize',
        'gloveLeftRight',
        'gloveGender',
        'food',
      ];

      const objectToSubmit = { ...form };

      if (i18n.language === 'en') {
        requiredFields.splice(requiredFields.indexOf('nameEng'), 1);
      }

      if (form.recipient === '본인') {
        objectToSubmit.recipientName = form.name;
        objectToSubmit.recipientPhoneNumber = form.phoneNumber;
        objectToSubmit.recipientRelation = '';
        requiredFields.splice(requiredFields.indexOf('recipientName'), 1);
        requiredFields.splice(requiredFields.indexOf('recipientPhoneNumber'), 1);
        requiredFields.splice(requiredFields.indexOf('recipientRelation'), 1);
      }

      if (form.flight === '미이용') {
        objectToSubmit.flightDeparture = '';
        objectToSubmit.flightArrival = '';
        requiredFields.splice(requiredFields.indexOf('flightDeparture'), 1);
        requiredFields.splice(requiredFields.indexOf('flightArrival'), 1);
      }

      if (form.flight === '이용') {
        if (isDepartureDisabled) {
          objectToSubmit.flightDeparture = '김포 → 부산/김해 KE 07:00';
          requiredFields.splice(requiredFields.indexOf('flightDeparture'), 1);
        }

        if (isArrivalDisabled) {
          objectToSubmit.flightArrival = '부산/김해 → 김포 KE 20:00';
          requiredFields.splice(requiredFields.indexOf('flightArrival'), 1);
        }
      }

      if (form.bagService === '미이용') {
        objectToSubmit.bagAddress = '';
        objectToSubmit.bagScheduleDate = '';
        objectToSubmit.bagServicePhoneNumber = '';
        requiredFields.splice(requiredFields.indexOf('bagAddress'), 1);
        requiredFields.splice(requiredFields.indexOf('bagScheduleDate'), 1);
        requiredFields.splice(requiredFields.indexOf('bagServicePhoneNumber'), 1);
      }

      if (form.gloveGender === 'M' && !['left', 'right'].includes(form.gloveLeftRight)) {
        objectToSubmit.gloveLeftRight = '';
      }

      const missingFields = requiredFields.filter(field => !objectToSubmit[field as keyof typeof objectToSubmit]);

      if (missingFields.length) {
        openAlertDialog(t('error'), `${t('formError')} ${missingFields.map(field => t(field)).join(', ')}`);
        return;
      }

      if (!isPrivacyAgreed) {
        openAlertDialog(t('error'), t('agreementError'));
        return;
      }

      if (participantInfo) {
        fetch(`${backendURL}nexen-api/participants/${participantInfo.pHash}`, {
          method: "PUT",
          body: JSON.stringify(objectToSubmit),
          headers: {
            'content-type': 'application/json',
          }
        })
          .then(response => {
            if (!response.ok) {
              throw new Error(t('networkError'));
            }
            return response.json()
          })
          .then(response => {
            if (response.error) {
              openAlertDialog(t('error'), response.error);
            } else {
              openAlertDialog(t('notification'), t('submitSuccess'));

              setTimeout(() => {
                history.push('/done');
              }, 750);
            }
          })
          .catch(error => {
            openAlertDialog(t('error'), t(error.message));
          })
      }
    },
  });


  return (
    <form onSubmit={formik.handleSubmit}>
      <div className={classes.paper}>
        <Container maxWidth="xs">
          <img src={Logo} alt="logo" style={{ width: '100%' }} />
        </Container>
        <Stack sx={{ my: 2 }} spacing={2} direction="row">
          <Button variant={i18n.language === 'ko' ? 'contained' : 'outlined'} startIcon={<span className="fi fi-kr"></span>} onClick={() => i18n.changeLanguage('ko')}>
            한국어
          </Button>
          <Button variant={i18n.language === 'en' ? 'contained' : 'outlined'} startIcon={<span className="fi fi-us"></span>} onClick={() => i18n.changeLanguage('en')}>
            English
          </Button>
        </Stack>
        <Typography variant="h6" gutterBottom textAlign="center" sx={{ whiteSpace: isXs ? 'pre-wrap' : 'normal' }}>
          {t("formTitle")}
        </Typography>
        <Typography variant="subtitle1">
          {t("privacyTitle")}
        </Typography>
        <Typography variant="caption" gutterBottom sx={{ whiteSpace: isXs ? 'pre-line' : 'pre-wrap', textAlign: 'justify' }}>
          {privacyContent}
        </Typography>
        <RadioGroup row>
          <FormControlLabel control={<Radio size="small" />} label={t('yes')} value="Y" onClick={() => setIsPrivacyAgreed(true)} />
          <FormControlLabel control={<Radio size="small" />} label={t('no')} value="N" onClick={() => setIsPrivacyAgreed(false)} />
        </RadioGroup>
        <Card className={classes.form}>
          <CardContent>
            <List>
              <InputLabel>
                {t('name')}
                {i18n.language === 'en' ? (
                  <Typography variant="body2" sx={{ color: 'rgba(0, 0, 0, 0.6)', whiteSpace: 'initial', textAlign: 'justify' }}>
                    {t('fullNameNotice')}
                  </Typography>
                ) : null}
              </InputLabel>
              <ListItem>
                <TextField fullWidth variant="outlined" name="name" onChange={formik.handleChange} value={formik.values.name} />
              </ListItem>
              {
                i18n.language === 'ko' ? (<>
                  <InputLabel>
                    {t('fullName')}
                    <Typography variant="body2" sx={{ color: 'rgba(0, 0, 0, 0.6)', whiteSpace: 'initial', textAlign: 'justify' }}>
                      {t('fullNameNotice')}
                    </Typography>
                  </InputLabel>
                  <ListItem>
                    <TextField fullWidth variant="outlined" name="nameEng" onChange={formik.handleChange} value={formik.values.nameEng} />
                  </ListItem>
                </>) : null
              }
              <InputLabel>{t('gender')}</InputLabel>
              <ListItem>
                <RadioGroup row onChange={(event) => {
                  formik.handleChange(event);
                }} value={formik.values.gender} name="gender">
                  <FormControlLabel control={<Radio />} label={t('male')} value="M" />
                  <FormControlLabel control={<Radio />} label={t('female')} value="F" />
                </RadioGroup>
              </ListItem>
              <InputLabel>{t('birth')}</InputLabel>
              <ListItem>
                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={i18n.language}>
                  <DatePicker sx={{ width: '100%' }} name="birthdate" value={formik.values.birthdate} onChange={(value) => formik.setFieldValue("birthdate", value, true)} />
                </LocalizationProvider>
              </ListItem>
              <InputLabel>{t('nationality')}</InputLabel>
              <ListItem>
                <TextField fullWidth variant="outlined" name="nationality" onChange={formik.handleChange} value={formik.values.nationality} />
              </ListItem>
              <InputLabel>{t('address')}</InputLabel>
              <ListItem>
                <TextField fullWidth variant="outlined" name="address" onChange={formik.handleChange} value={formik.values.address} multiline />
              </ListItem>
              <InputLabel>{t('company')}</InputLabel>
              <ListItem>
                <TextField fullWidth variant="outlined"
                  name="company" value={formik.values.company} onChange={formik.handleChange}
                />
              </ListItem>
              <InputLabel>{t('position')}</InputLabel>
              <ListItem>
                <TextField fullWidth variant="outlined"
                  name="position" value={formik.values.position} onChange={formik.handleChange}
                />
              </ListItem>
              <InputLabel>{t('phoneNumber')}</InputLabel>
              <ListItem>
                <TextField fullWidth variant="outlined" multiline
                  name="phoneNumber" value={formik.values.phoneNumber} onChange={formik.handleChange}
                />
              </ListItem>
              <InputLabel>{t('recipient')}</InputLabel>
              <ListItem>
                <RadioGroup row onChange={formik.handleChange} value={formik.values.recipient} name="recipient">
                  <FormControlLabel control={<Radio />} label={t('self')} value="본인" />
                  <FormControlLabel control={<Radio />} label={t('other')} value="기타" />
                </RadioGroup>
              </ListItem>
              {formik.values.recipient === '기타' ? (
                <>
                  <InputLabel>{t('recipientName')}</InputLabel>
                  <ListItem>
                    <TextField fullWidth variant="outlined"
                      name="recipientName" value={formik.values.recipientName} onChange={formik.handleChange}
                    />
                  </ListItem>
                  <InputLabel>{t('recipientPhoneNumber')}</InputLabel>
                  <ListItem>
                    <TextField fullWidth variant="outlined"
                      name="recipientPhoneNumber" value={formik.values.recipientPhoneNumber} onChange={formik.handleChange}
                    />
                  </ListItem>
                  <InputLabel>{t('recipientRelation')}</InputLabel>
                  <ListItem>
                    <TextField fullWidth variant="outlined"
                      name="recipientRelation" value={formik.values.recipientRelation} onChange={formik.handleChange}
                    />
                  </ListItem>
                </>
              ) : null}
              <InputLabel>{t('preferredCallSchedule')}</InputLabel>
              <ListItem>
                <Select fullWidth variant="outlined"
                  displayEmpty
                  sx={{ mr: 1 }}
                  name="preferredCallDate" value={formik.values.preferredCallDate} onChange={formik.handleChange}
                >
                  <MenuItem value="" disabled>{t('date')}</MenuItem>
                  <MenuItem value="03/23">{`${t('march')} 23${t('day')}(${t('monday')})`}</MenuItem>
                  <MenuItem value="03/24">{`${t('march')} 24${t('day')}(${t('tuesday')})`}</MenuItem>
                  <MenuItem value="03/25">{`${t('march')} 25${t('day')}(${t('wednesday')})`}</MenuItem>
                  <MenuItem value="03/26">{`${t('march')} 26${t('day')}(${t('thursday')})`}</MenuItem>
                  <MenuItem value="03/27">{`${t('march')} 27${t('day')}(${t('friday')})`}</MenuItem>
                  <MenuItem value="03/30">{`${t('march')} 30${t('day')}(${t('monday')})`}</MenuItem>
                  <MenuItem value="03/31">{`${t('march')} 31${t('day')}(${t('tuesday')})`}</MenuItem>
                </Select>
                <Select fullWidth variant="outlined"
                  displayEmpty
                  sx={{ ml: 1 }}
                  name="preferredCallTime" value={formik.values.preferredCallTime} onChange={formik.handleChange}
                >
                  <MenuItem value="" disabled>{t('time')}</MenuItem>
                  {callTimeOptions.map(option => (
                    <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
                  ))}
                </Select>
              </ListItem>
              <InputLabel sx={{ whiteSpace: 'pre-line' }}>{t('flight')}</InputLabel>
              <ListItem>
                <RadioGroup row onChange={formik.handleChange} value={formik.values.flight} name="flight">
                  <FormControlLabel control={<Radio />} label={t('o')} value="이용" />
                  <FormControlLabel control={<Radio />} label={t('x')} value="미이용" />
                </RadioGroup>
              </ListItem>
              {formik.values.flight === '이용' ? (
                <>
                  <InputLabel>
                    {t('flightDeparture')}
                    <Typography variant="body2" sx={{ color: 'rgba(0, 0, 0, 0.6)', whiteSpace: 'pre-line', textAlign: 'justify' }}>
                      {t('flightOneWayNotice')}
                    </Typography>
                  </InputLabel>
                  <ListItem>
                    <RadioGroup>
                      <FormControlLabel control={<Radio />} label={<Typography variant="body2" sx={(theme) => ({ [theme.breakpoints.down('sm')]: { fontSize: i18n.language === 'en' ? '0.6rem' : undefined } })}>{t('departureDefault')}</Typography>} onClick={() => setIsDepartureDisabled(true)}
                        value="departureDefault"
                        checked={isDepartureDisabled}
                      />
                      <FormControlLabel control={<Radio />} label={
                        <TextField fullWidth variant="outlined" placeholder={t('other')} size="small"
                          name="flightDeparture" value={formik.values.flightDeparture} onChange={formik.handleChange}
                          disabled={isDepartureDisabled}
                        />
                      }
                        value="departureOther"
                        onClick={() => setIsDepartureDisabled(false)} />
                    </RadioGroup>
                  </ListItem>
                  <InputLabel>{t('flightArrival')}</InputLabel>
                  <ListItem>
                    <RadioGroup>
                      <FormControlLabel
                        control={<Radio />} label={<Typography variant="body2" sx={(theme) => ({ [theme.breakpoints.down('sm')]: { fontSize: i18n.language === 'en' ? '0.6rem' : undefined } })}>{t('arrivalDefault')}</Typography>} onClick={() => setIsArrivalDisabled(true)}
                        value="arrivalDefault"
                        checked={isArrivalDisabled}
                      />
                      <FormControlLabel control={<Radio />} label={
                        <TextField fullWidth variant="outlined" placeholder={t('other')} size="small"
                          name="flightArrival" value={formik.values.flightArrival} onChange={formik.handleChange}
                          disabled={isArrivalDisabled}
                        />
                      }
                        value="arrivalOther"
                        onClick={() => setIsArrivalDisabled(false)} />
                    </RadioGroup>
                  </ListItem>
                </>
              ) : null}
              <InputLabel sx={{ whiteSpace: 'pre-line' }}>
                {t('bagService')}<br />
                <Typography variant="body2" sx={{ color: 'rgba(0, 0, 0, 0.6)', whiteSpace: 'pre-line', textAlign: 'justify' }}>
                  {t('bagServiceHelp').replace(/^ +/gm, '')}
                </Typography>
              </InputLabel>
              <ListItem>
                <RadioGroup row onChange={formik.handleChange} value={formik.values.bagService} name="bagService">
                  <FormControlLabel control={<Radio />} label={t('o')} value="이용" />
                  <FormControlLabel control={<Radio />} label={t('x')} value="미이용" />
                </RadioGroup>
              </ListItem>
              {formik.values.bagService === '이용'
                ? (
                  <>
                    <InputLabel sx={{ whiteSpace: 'initial' }}>{t('bagAddress')}</InputLabel>
                    <ListItem>
                      <TextField fullWidth variant="outlined"
                        name="bagAddress" value={formik.values.bagAddress} onChange={formik.handleChange}
                        multiline
                      />
                    </ListItem>
                    <InputLabel sx={{ whiteSpace: 'initial' }}>{t('bagServicePhoneNumber')}</InputLabel>
                    <ListItem>
                      <TextField fullWidth variant="outlined"
                        name="bagServicePhoneNumber" value={formik.values.bagServicePhoneNumber} onChange={formik.handleChange}
                      />
                    </ListItem>
                    <InputLabel>{t('bagScheduleDate')}</InputLabel>
                    <ListItem>
                      <Select fullWidth variant="outlined"
                        displayEmpty
                        sx={{ mr: 1 }}
                        name="bagScheduleDate" value={formik.values.bagScheduleDate} onChange={formik.handleChange}
                      >
                        <MenuItem value="" disabled>{t('bagScheduleDate')}</MenuItem>
                        <MenuItem value="04/09">{`${t('april')} 9${t('day')}(${t('thursday')})`}</MenuItem>
                        <MenuItem value="04/10">{`${t('april')} 10${t('day')}(${t('friday')})`}</MenuItem>
                        <MenuItem value="04/11">{`${t('april')} 11${t('day')}(${t('saturday')})`}</MenuItem>
                        <MenuItem value="04/12">{`${t('april')} 12${t('day')}(${t('sunday')})`}</MenuItem>
                      </Select>
                    </ListItem>
                  </>
                ) : null}
              <InputLabel>
                {t('shoeSize')}
                <Typography variant="body2" sx={{ color: 'rgba(0, 0, 0, 0.6)', whiteSpace: isXs ? 'pre-line' : 'initial', textAlign: 'justify' }}>
                  {isXs ? t('shoeSizeNoticeXs') : t('shoeSizeNotice')}
                </Typography>
              </InputLabel>
              <ListItem>
                <Select fullWidth variant="outlined"
                  displayEmpty
                  sx={{ mr: 1 }}
                  name="shoeGender" value={formik.values.shoeGender} onChange={(event) => {
                    formik.handleChange(event);
                    formik.setFieldValue('shoeSize', '');
                  }}
                >
                  <MenuItem value="" disabled>{t('shoeGender')}</MenuItem>
                  <MenuItem value="M">{t('male')}</MenuItem>
                  <MenuItem value="F">{t('female')}</MenuItem>
                </Select>
                <Select fullWidth variant="outlined"
                  displayEmpty
                  sx={{ ml: 1 }}
                  name="shoeSize" value={formik.values.shoeSize} onChange={formik.handleChange}
                >
                  <MenuItem value="" disabled>{t('size')}</MenuItem>
                  {formik.values.shoeGender === 'M' ? ['250', '255', '260', '265', '270', '275', '280', '285', '290'].map(size => (
                    <MenuItem key={size} value={size}>{size}</MenuItem>
                  )) : null}
                  {formik.values.shoeGender === 'F' ? ['225', '230', '235', '240', '245', '250'].map(size => (
                    <MenuItem key={size} value={size}>{size}</MenuItem>
                  )) : null}
                </Select>
              </ListItem>
              <InputLabel>
                {t('gloveSize')}
                <Typography variant="body2" sx={{ color: 'rgba(0, 0, 0, 0.6)', whiteSpace: 'initial', textAlign: 'justify' }}>
                  {t('gloveDirectionNotice')}
                </Typography>
              </InputLabel>
              <ListItem>
                <Select fullWidth variant="outlined"
                  displayEmpty
                  sx={{ mb: 1 }}
                  name="gloveGender" value={formik.values.gloveGender} onChange={(event) => {
                    const nextGloveGender = event.target.value;
                    formik.handleChange(event);

                    if (nextGloveGender === 'M' && formik.values.gloveLeftRight === 'both') {
                      formik.setFieldValue('gloveLeftRight', '');
                    }

                    if (nextGloveGender === 'F' && (formik.values.gloveLeftRight === 'left' || formik.values.gloveLeftRight === 'right')) {
                      formik.setFieldValue('gloveLeftRight', 'both');
                    }

                    if (!getAllowedGloveSizes(nextGloveGender).includes(formik.values.gloveSize)) {
                      formik.setFieldValue('gloveSize', '');
                    }
                  }}
                >
                  <MenuItem value="" disabled>{t('gloveGender')}</MenuItem>
                  <MenuItem value="M">{t('male')}</MenuItem>
                  <MenuItem value="F">{t('female')}</MenuItem>
                </Select>
              </ListItem>
              <ListItem>
                <Select fullWidth variant="outlined"
                  displayEmpty
                  sx={{ mr: 1 }}
                  name="gloveLeftRight" value={formik.values.gloveLeftRight} onChange={formik.handleChange}
                >
                  <MenuItem value="" disabled>{t('leftRight')}</MenuItem>
                  {formik.values.gloveGender === 'M' ? ['left', 'right'].map(hand => <MenuItem key={hand} value={hand}>{t(hand)}</MenuItem>) : null}
                  {formik.values.gloveGender === 'F' ? <MenuItem value="both">{t('both')}</MenuItem> : null}
                </Select>
                <Select fullWidth variant="outlined"
                  displayEmpty
                  sx={{ ml: 1 }}
                  name="gloveSize" value={formik.values.gloveSize} onChange={formik.handleChange}
                >
                  <MenuItem value="" disabled>{t('size')}</MenuItem>
                  {getAllowedGloveSizes(formik.values.gloveGender).map(size => <MenuItem key={size} value={size}>{size}</MenuItem>)}
                </Select>
              </ListItem>
              <InputLabel sx={{ whiteSpace: 'pre-line' }}>{t('food')}</InputLabel>
              <ListItem>
                <TextField fullWidth variant="outlined"
                  name="food" value={formik.values.food} onChange={formik.handleChange}
                />
              </ListItem>
            </List>
            <Typography variant="body2" sx={{ textAlign: 'justify', wordBreak: 'keep-all', color: 'rgba(0, 0, 0, 0.6)', whiteSpace: isXs ? 'pre-line' : 'normal' }}>
              {(isXs ? t('additionalXs') : t('additional')).replace(/^ +/gm, '')}</Typography>
            <Stack direction="row" justifyContent="center" alignItems="center" gap={2} sx={{ mt: 2 }}>
              <Button color="primary" type="submit" variant="contained">
                {t("submit")}
              </Button>
            </Stack>
          </CardContent>
        </Card>
      </div>
      <Dialog
        open={isAlertDialogOpen}
        onClose={() => setIsAlertDialogOpen(false)}
      >
        <DialogTitle>
          {alertTitle}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {alertMessage}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setIsAlertDialogOpen(false)} color="primary">
            {t("close")}
          </Button>
        </DialogActions>
      </Dialog>
    </form >
  );
}
